<template>
  <div class="app-wrap">
    <div v-if="isLoading" class="se-pre-con"></div>
    <img alt="Gomobile logo" src="@/assets/logo.svg" class="company-logo" />
    <form v-if="!showThanks" action="#">
      <div class="paragraph-wrap">
        <h1 class="text-bold text-primary no-top-margin">
          {{ $t("main.header") }}
        </h1>
        <p class="paragraph">
          <i18next :translation="$t('main.text1')">
            <template #shortFormLink>
              <RouterLink
                class="orange-text"
                :to="{
                  path: '/short-form',
                  query: $route.query,
                }"
                >{{ $t("main.shortFormHere") }}</RouterLink
              >
            </template>
          </i18next>
        </p>
        <p class="paragraph">{{ $t("main.text2") }}</p>
        <h2 class="text-bold text-primary">{{ $t("name.header") }}</h2>
        <TextareaAutosize
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.name"
          type="text"
          :min-height="10"
          :max-height="350"
          :placeholder="$t('name.placeholder')"
        />
        <h2 class="top-wrap text-bold text-primary">
          {{ $t("secondBlock.header") }}
        </h2>
        <ThePointsbar
          @change="feedbackData.secondBlockRating = $event"
          :size="10"
          code="secondBlockRating"
          :full-name="true"
        />
        <TextareaAutosize
        v-if="feedbackData.secondBlockRating"
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.secondBlockText"
          :min-height="10"
          :max-height="350"
          name="become_better"
          :placeholder="$t('secondBlock.comment')"
        />
        <h2 class="text-bold text-primary">Насколько вы удовлетворены АК на фоне других предложений?</h2>
        <ThePointsbar
          @change="feedbackData.ak = $event"
          :size="5"
          code="ak"
          :full-name="false"
        />
        <TextareaAutosize
        v-if="feedbackData.ak"
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.akText"
          :min-height="10"
          :max-height="350"
          name="become_better"
          :placeholder="$t('secondBlock.comment')"
        />
        <h2 class="text-bold text-primary">Насколько вы удовлетворены рибейтной политикой?</h2>
        <ThePointsbar
          @change="feedbackData.ribet = $event"
          :size="5"
          code="ribet"
          :full-name="false"
        />
        <TextareaAutosize
        v-if="feedbackData.ribet"
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.ribetText"
          :min-height="10"
          :max-height="350"
          name="become_better"
          :placeholder="$t('secondBlock.comment')"
        />
        <h2 class="top-wrap text-bold text-primary">
          {{ $t("improve.header") }}
        </h2>
        <TextareaAutosize
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.update"
          :min-height="10"
          :max-height="350"
          name="become_better"
          :placeholder="$t('improve.placeholder')"
        />
        <h2 class="text-bold text-primary">Оцените работу клиентского сервиса</h2>
        <p class="label-text">Формат коммуникации, скорость ответа:</p>
        <ThePointsbar
          @change="feedbackData.speed = $event"
          :size="5"
          code="speed"
          :full-name="false"
        />
        <TextareaAutosize
        v-if="feedbackData.speed"
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.speedRating"
          :min-height="10"
          :max-height="350"
          name="become_better"
          :placeholder="$t('secondBlock.comment')"
        />
       
        <p class="label-text">Оказание технической поддержки:</p>
        <ThePointsbar
          @change="feedbackData.support = $event"
          :size="5"
          code="support"
          :full-name="false"
        />
        <TextareaAutosize
        v-if="feedbackData.support"
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.supportRating"
          :min-height="10"
          :max-height="350"
          name="become_better"
          :placeholder="$t('secondBlock.comment')"
        />
        <p class="label-text">Проведение сверки и подготовка документов:</p>
        <ThePointsbar
          @change="feedbackData.doc = $event"
          :size="5"
          code="doc"
          :full-name="false"
        />
        <TextareaAutosize
        v-if="feedbackData.doc"
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.docRating"
          :min-height="10"
          :max-height="350"
          name="become_better"
          :placeholder="$t('secondBlock.comment')"
        />
        <h2 class="top-wrap text-bold text-primary">
          Помогите нам стать лучше (общий фидбек по работе в рамках Resell размещений и что бы хотелось улучшить)
        </h2>
        <TextareaAutosize
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.feedback"
          :min-height="10"
          :max-height="350"
          :placeholder="$t('improve.placeholder')"
          name="personal_feedback"
        />
      </div>
      <div class="paragraph-wrap">
        <h2
          :class="{ alertLine: isAlert }"
          class="top-wrap text-bold"
          id="must-answer"
        >
          <span class="text-primary custom-asterisk">*</span>
          {{ $t("recommendation.header") }}
          <span v-if="isAlert" class="text-primary custom-asterisk"
            >({{ $t("isNecessary.text") }})</span
          >
        </h2>
        <ThePointsbar
          @change="feedbackData.recomendation = $event"
          :size="10"
          code="recomendation"
          @alert="isAlert = $event"
          :alertLine="isAlert"
          :full-name="true"
        />
      </div>
      <button type="button" class="submit-button" @click="sendFeedback">
        <span>{{ $t("sendBtn") }}</span
        ><img src="@/assets/message.svg" />
      </button>
    </form>
    <div v-else class="thanks-text">
      <h1>{{ $t("thanks.header") }}</h1>
      <p>{{ $t("thanks.text1") }}</p>
      <p v-if="$i18next.language === 'ru'">
        {{ $t("thanks.text2") }} (<a
          class="enable-select"
          :href="`mailto: ${$t('thanks.email1')}`"
          >{{ $t("thanks.email1") }}</a
        >) {{ $t("thanks.text3") }} (<a
          class="enable-select"
          :href="`mailto: ${$t('thanks.email2')}`"
          >{{ $t("thanks.email2") }}</a
        >).
      </p>
      <p v-else>
        {{ $t("thanks.text2") }}
        <a class="enable-select" :href="`mailto: ${$t('thanks.email1')}`">{{
          $t("thanks.email1")
        }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import ThePointsbar from "@/components/ThePointsbar";
import { RouterLink } from "vue-router";
import TextareaAutosize from "@/components/TextareaAutosize.vue";
import API from "@/api";
import i18next from "i18next";

export default {
  name: "App",
  components: {
    ThePointsbar,
    TextareaAutosize,
    RouterLink,
  },
  data: function () {
    return {
      showThanks: false,
      isLoading: false,
      isAlert: false,
      feedbackData: {
        version: "v2",
        isShort: false,
        name: "",
        secondBlockRating:'',
        secondBlockText:'',
        ak:'',
        akText:'',
        ribet:'',
        ribetText:'',
        update:'',
        speed:'',
        speedRating:'',
        support:'',
        supportRating:'',
        doc:'',
        docRating:'',
        feedback: "",
        recomendation: "",
        paramName: "",
      },
    };
  },

  methods: {
    sendFeedback: async function () {
     
      if (this.feedbackData.recomendation.length === 0) {
        document
          .getElementById("must-answer")
          .scrollIntoView({ block: "center", behavior: "smooth" });
        this.isAlert = true;
        return;
      }

      this.isLoading = true;
      const that = this;
      try {
        if (this.feedbackData.paramName === "") {
          this.feedbackData.paramName =
            "Клиент стер уникальный параметр ссылки";
        }
        const api = new API();
        await api.push(this.feedbackData).then(function () {
          that.isLoading = false;
        });
        that.isLoading = false;
      } catch (e) {
        console.error(e);
      }
      this.showThanks = true;
    },
    getData: async function () {
      try {
        const requestOptions = {
          method: "GET",
          redirect: "follow",
        };

        fetch(
          "https://script.google.com/macros/s/AKfycbwbLK1711GhF3e9QZX8kHoLqBKaHQdUmhTAxHmw9oVZPdp3EHKvSawR4xC4MuH3XSD1Rw/exec",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            const locat = location;
            let index = 0;
            let end = 0;
            for (let i = 0; i < result.length; i++) {
              if ("Resell" === result[i][0]) {
                index = i;
              }
              if ("GoTech" === result[i][0]) {
                end = i;
              }
            }
            result = result.slice(index + 1, end);
            for (let i = 0; i < result.length; i++) {
              let param = result[i][1].slice(result[i][1].indexOf("?"));
              if (param == locat.search) {
                this.feedbackData.paramName = result[i][0];
                // console.log(this.feedbackData.paramName);
                return;
              }
            }
          })
          .catch((error) => console.error(error));
      } catch (err) {
        console.log(err);
      }
    },
    addHowFound(val) {
      this.feedbackData.fullRating = val.text;
    },
  },
  computed: {
    screenWidth() {
      return window.innerWidth;
    },
    isActiveOther() {
      if (
        this.feedbackData.howFound.includes(
          i18next.t("fullRating.values", { returnObjects: true }).at(-1)
        )
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
 .label-text {
        display: inline;
        font-size: x-large;
        font-weight: bold;
        color: #ff7900;
        text-align: left;
        font-family: "Noto Sans", sans-serif;
    } 

    @media only screen and (max-width: 320px) and (max-height: 568px) and (-webkit-device-pixel-ratio: 2),
        only screen and (max-width: 375px) and (max-height: 667px) and (-webkit-device-pixel-ratio: 2),
        only screen and (max-width: 375px) and (max-height: 812px),
        only screen and (max-width: 414px) and (max-height: 736px) and (-webkit-device-pixel-ratio: 3),
        only screen and (max-width: 411px) and (max-height: 731px),
        only screen and (max-width: 411px) and (max-height: 823px) {
       

        .label-text {
            display: inline;
            font-size: small;
            text-align: left;
            font-family: "Noto Sans", sans-serif;
        }
    }
</style>
